import { render } from "./HomepageTwa.vue?vue&type=template&id=3bd1d6d0&scoped=true"
import script from "./HomepageTwa.vue?vue&type=script&lang=js"
export * from "./HomepageTwa.vue?vue&type=script&lang=js"

import "./HomepageTwa.vue?vue&type=style&index=0&id=3bd1d6d0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd1d6d0"]])

export default __exports__